import React, { useEffect, useState } from 'react';
import { useClerk } from '@clerk/clerk-react';

// Shown only if the sign-in service hasn't loaded after a few seconds.
export function ClerkStatusNotice() {
  const clerk = useClerk();
  const [waited, setWaited] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setWaited(true), 8000);
    return () => clearTimeout(t);
  }, []);

  if (clerk.loaded || !waited) return null;
  return (
    <p className="mb-6 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800" data-testid="clerk-unavailable-notice">
      Sign-in is temporarily unavailable. Please try again shortly, or continue as a guest to browse and book.
    </p>
  );
}
